import {
  SelectInput,
  DateInput,
  NumberInput,
  ReferenceArrayInput,
  SelectArrayInput,
} from "react-admin";
import { Fragment } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { required } from "react-admin";

export const UserDynamicFields = () => {
  const { control } = useFormContext();
  const userType = useWatch({ control, name: "type" });

  return (
    <Fragment>
      {/* Fields for farmer and buyer */}
      {(userType === "farmer" || userType === "buyer") && (
        <>
          <SelectInput
            source="gender"
            label="Gender"
            choices={[
              { id: "male", name: "ذكر (Male)" },
              { id: "female", name: "أنثى (Female)" },
            ]}
            validate={[required()]}
          />
          <DateInput
            source="dob"
            label="Date of Birth"
            validate={[required()]}
          />
        </>
      )}

      {/* Fields for cooperatives */}
      {(userType === "agriculture_cooperative" || userType === "consumer_cooperative") && (
        <>
          <SelectInput
            source="cooperativeType"
            label="Cooperative Type"
            choices={[
              { id: "agriculture", name: "زراعية إنتاجية" },
              { id: "consumer", name: "إستهلاكية" },
            ]}
            validate={[required()]}
            defaultValue={
              userType === "agriculture_cooperative" ? "agriculture" : 
              userType === "consumer_cooperative" ? "consumer" : undefined
            }
          />
          <NumberInput
            source="NoOfMembers"
            label="Number of Members"
            validate={[required()]}
          />
        </>
      )}

      {/* Subcategories for farmer, buyer, and cooperatives */}
      {(userType === "farmer" || 
        userType === "buyer" || 
        userType === "agriculture_cooperative" || 
        userType === "consumer_cooperative") && (
        <ReferenceArrayInput
          source="subCategory_id"
          reference="sub_category"
          label="المحصول (Products/Crops)"
          validate={[required()]}
        >
          <SelectArrayInput optionText="name" />
        </ReferenceArrayInput>
      )}

      {/* Services for service providers */}
      {userType === "service_provider" && (
        <ReferenceArrayInput
          source="service_id"
          reference="servicetypes"
          label="الخدمة (Services)"
          validate={[required()]}
        >
          <SelectArrayInput optionText="name" />
        </ReferenceArrayInput>
      )}
    </Fragment>
  );
};

export default UserDynamicFields;